import { eventsSender } from 'globalState/global-state.js';

const isMobile = window.config.state.theme === 'mobile';
const mobileSource = document.querySelector('#search-mobile-list')
    ? 'search'
    : 'good-list';
const desktopSource = document.querySelector('#search-page')
    ? 'search'
    : 'good-list';
const defaultSource = isMobile ? mobileSource : desktopSource;

export const openModal = () => {
    try {
        eventsSender('filter', 'fastDeliveryModal', {
            source: defaultSource,
        });
    } catch (err) {
        console.error(err);
    }
};

export const selectedPointByAddress = () => {
    try {
        eventsSender('filter', 'fastDeliveryModal', {
            source: defaultSource,
        });
    } catch (err) {
        console.error(err);
    }
};

export const selectedPointByMap = () => {
    try {
        eventsSender('filter', 'fastDeliveryModal', {
            source: defaultSource,
        });
    } catch (err) {
        console.error(err);
    }
};
